// extracted by mini-css-extract-plugin
module.exports = {"pillText":"PillText_pillText__1ALkk","isPassive":"PillText_isPassive__3gLK6"};